<template>
    <div class="v-input" v-for="input in inputs" :key="input.id" :for="input.id">
        <p v-if="input.label" class="label">
            {{ input.label }}
            <span v-if="input.hint" class="label-hint">
                <simple-svg :src="InfoIcon" custom-class-name="icon" width="14" height="14" />
                <span class="hint-tooltip">{{ input.hint }}</span>
            </span>
        </p>
        <input :type="getType(input)" :placeholder="input.placeholder" :value="getDisplayValue(input)"
            @input="handleInput($event, input)" @keypress="onKeypress($event, input)"
            :class="{ 'input-error': input.isError }" :style="{ 'min-width': minWidth }"
            :inputmode="input.type === 'number' ? 'numeric' : undefined" />
    </div>
</template>

<script>
import InfoIcon from '@/assets/icons/Circle_Warning.svg';

export default {
    name: 'VInput',
    data() {
        return { InfoIcon };
    },
    emits: ['input'],
    props: {
        inputs: {
            type: Array,
            required: true,
        },
        minWidth: {
            type: String,
            default: '250px',
        }
    },
    methods: {
        getType(input) {
            return input.type === 'number' ? 'text' : input.type;
        },
        getDisplayValue(input) {
            if (input.activeMask === 'phone') {
                return this.formatPhone(input.value);
            }
            if (input.type === 'number' && input.value) {
                return String(input.value)
                    .replace(/\s/g, '')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
            return input.value;
        },
        formatPhone(value) {
            if (!value) return '';
            let clean = String(value);

            if (clean[0] === '7') {
                let formatted = '+7';
                if (clean.length > 1) {
                    formatted += ' (' + clean.substring(1, 4);
                }
                if (clean.length >= 5) {
                    formatted += ') ' + clean.substring(4, 7);
                }
                if (clean.length >= 8) {
                    formatted += ' ' + clean.substring(7, 9);
                }
                if (clean.length >= 10) {
                    formatted += '-' + clean.substring(9, 11);
                }
                return formatted;
            }
            return '+' + clean;
        },
        handleInput(event, input) {
            if (input.activeMask === 'phone') {
                let rawValue = event.target.value.replace(/\D/g, '');
                let clean = rawValue;

                if (['7', '8', '9'].indexOf(clean[0]) > -1) {
                    if (clean[0] === '8') {
                        clean = '7' + clean.substring(1);
                    }
                    if (clean[0] === '9') {
                        clean = '7' + clean;
                    }
                }

                clean = clean.substring(0, 11);
                input.value = clean;
                event.target.value = this.formatPhone(clean);
            } else if (input.type === 'number') {
                let rawValue = event.target.value.replace(/\s/g, '');
                let clean = rawValue.replace(/[^0-9.]/g, '');

                if ((clean.match(/\./g) || []).length > 1) {
                    clean = clean.substring(0, clean.length - 1);
                }

                if (input.value === clean) {
                    event.target.value = this.getDisplayValue(input);
                }

                input.value = clean;
            } else {
                input.value = event.target.value;
            }
            this.$emit('input', event);
        },
        onKeypress(event, input) {
            if (input.type === 'number' || input.activeMask === 'phone') {
                const charCode = (event.which) ? event.which : event.keyCode;
                // Allow digits (48-57)
                // For number type allow dot (46)
                if ((charCode < 48 || charCode > 57) && (input.activeMask === 'phone' || charCode !== 46)) {
                    event.preventDefault();
                }
                // Prevent duplicate dots for numbers
                if (input.type === 'number' && charCode === 46 && String(input.value).includes('.')) {
                    event.preventDefault();
                }
            }
        }
    }
}
</script>

<style lang="scss">
.v-input {
    .label {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        gap: 4px;

        .label-hint {
            position: relative;
            display: inline-flex;
            align-items: center;
            cursor: help;

            .icon {
                opacity: 0.6;
            }

            .hint-tooltip {
                display: none;
                position: absolute;
                bottom: calc(100% + 6px);
                left: 50%;
                transform: translateX(-50%);
                background-color: var(--color-bg-dark);
                border: 1px solid var(--color-border);
                color: var(--color-text);
                font-size: 12px;
                font-weight: 400;
                padding: 6px 10px;
                border-radius: 6px;
                white-space: normal;
                width: 220px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                z-index: 100;
                line-height: 1.4;
            }

            &:hover .hint-tooltip {
                display: block;
            }
        }
    }
}

input {
    box-sizing: border-box;
    background-color: var(--color-input-bg);
    border: solid 1px var(--color-border);
    border-radius: 5px;
    padding: 6px 8px;
    color: var(--color-input-text);
    //min-width: 250px;
    outline: none;
    transition: all 0.2s ease;

    &.input-error {
        //border: solid 1px var(--color-red);
        //background-color: var(--color-input-bg);
        /* цвет фона */
        box-shadow: 0 0 6px var(--color-input-error);
        /* эффект свечения */
    }
}

input:focus {
    border: solid 1px;
    border-color: var(--color-input-focus);
    background-color: var(--color-input-bg);
    /* цвет фона */
    box-shadow: 0 0 6px var(--color-input-focus);
    /* эффект свечения */

    &.input-error {
        border: solid 1px var(--color-input-error);
        //background-color: var(--color-input-bg);
        /* цвет фона */
        box-shadow: 0 0 6px var(--color-input-error);
        /* эффект свечения */
    }
}
</style>
